import type { NDateLocale } from './enUS'
import { enZA } from 'date-fns/locale'

const dateZuZA: NDateLocale = {
  name: 'zu-ZA',
  locale: enZA
}

export default dateZuZA
